"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.orientationProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../assets/icons/controls/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    stepper: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      backgroundColor: "transparent",
      zIndex: 0,
      "&.MuiStepper-vertical": {
        alignItems: "flex-start",
        "& .MuiStepContent-root": {
          marginLeft: theme.spacing(3),
          paddingLeft: theme.spacing(3),
          "& .MuiCollapse-entered": {
            paddingTop: theme.spacing(2)
          },
          "& .MuiButtonBase-root": {
            marginTop: theme.spacing(1)
          }
        },
        "& .MuiStepButton-vertical": {
          "&:after": {
            borderLeftWidth: 1,
            borderLeftColor: theme.palette.grey[400],
            borderLeftStyle: "solid",
            position: "absolute",
            content: "''",
            height: "100%",
            left: 24,
            top: 24,
            zIndex: -1
          }
        },
        "& .MuiStep-root": {
          "&:last-child": {
            "& .MuiStepButton-vertical": {
              "&:after": {
                display: "none"
              }
            }
          },
          "&.MuiStep-completed": {
            "& .MuiStepButton-vertical": {
              "&:after": {
                borderLeftColor: theme.palette.primary.main
              }
            }
          }
        },
        "& .MuiStepLabel-root": {
          "&.MuiStepLabel-alternativeLabel": {
            flexDirection: "row",
            alignItems: "flex-start"
          }
        },
        "& .MuiStepLabel-label": {
          "&.MuiStepLabel-alternativeLabel": {
            marginTop: 0,
            fontSize: theme.typography.h5.fontSize,
            textAlign: "left",
            paddingTop: 2
          }
        },
        "& .MuiStepLabel-iconContainer": {
          paddingRight: theme.spacing(1.5)
        },
        "& .MuiStepConnector-alternativeLabel": {
          left: 12,
          top: -24
        }
      },
      "& .MuiStepConnector-line": {
        "&.MuiStepConnector-lineVertical": {
          minHeight: theme.spacing(7)
        }
      },
      "& .MuiStepConnector-active": {
        "& .MuiStepConnector-line": {
          borderColor: theme.palette.primary.main
        }
      },
      "& .MuiStepConnector-completed": {
        "& .MuiStepConnector-line": {
          borderColor: theme.palette.primary.main
        }
      },
      "&.MuiStepper-horizontal": {
        "& .MuiStepLabel-alternativeLabel": {
          position: "relative",
          zIndex: 2
        },
        "& .MuiStepConnector-alternativeLabel": {
          top: 28,
          left: "calc(-50% + 4px)",
          right: "calc(50% + 4px)",
          position: "absolute",
          zIndex: 1
        }
      },
      "& .MuiStep-root": {
        "& .MuiStepButton-root": {
          position: "relative",
          zIndex: 2,
          margin: 0,
          padding: 0,
          "& .MuiStepButton-touchRipple": {
            display: "none"
          }
        }
      },
      "& .MuiStepLabel-label": {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.body1.fontSize,
        "&.MuiStepLabel-active": {
          fontWeight: "bold",
          color: theme.palette.text.primary
        },
        "&.MuiStepLabel-completed": {
          color: theme.palette.text.primary
        }
      }
    },
    stepButton: {
      margin: 0,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(2),
      width: "auto"
    }
  };
});

var stepIcon = function stepIcon(_ref) {
  var active = _ref.active,
      completed = _ref.completed;
  if (active) return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, {
    component: _icons.ic_Stepper__circle__selected,
    viewBox: "0 0 24 24"
  });
  if (completed) return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, {
    component: _icons.ic_Stepper__circle__completed,
    viewBox: "0 0 24 24"
  });
  return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, {
    component: _icons.ic_Stepper__circle,
    viewBox: "0 0 24 24"
  });
};

stepIcon.propTypes = {
  active: _propTypes.default.bool,
  completed: _propTypes.default.bool
};
stepIcon.defaultProps = {
  active: false,
  completed: false
};
/**
 * ** Steppers convey progress through numbered steps **
 */

var Steps = function Steps(_ref2) {
  var activeStep = _ref2.activeStep,
      steps = _ref2.steps,
      stepItems = _ref2.stepItems,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? "horizontal" : _ref2$orientation,
      action = _ref2.action;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Stepper, {
    className: styles.stepper,
    orientation: orientation,
    activeStep: activeStep,
    alternativeLabel: true
  }, steps.map(function (step, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Step, {
      key: step
    }, /*#__PURE__*/_react.default.createElement(_core.StepButton, {
      color: "inherit",
      onClick: function onClick() {
        return action(index);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.StepLabel, {
      className: styles.stepButton,
      StepIconComponent: stepIcon
    }, step)), orientation === "vertical" && /*#__PURE__*/_react.default.createElement(_core.StepContent, null, stepItems[index]));
  }));
};

Steps.propTypes = {
  /** The index of the active step */
  activeStep: _propTypes.default.number,

  /** The array of values to represented as steps */
  steps: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /** Vertical steps content (not used on horizontal) */
  stepItems: _propTypes.default.arrayOf(_propTypes.default.node),

  /** The orientation of the stepper */
  orientation: _propTypes.default.oneOf(["horizontal", "vertical"]),

  /** Action to call on the step (returns step index) */
  action: _propTypes.default.func.isRequired
};
Steps.defaultProps = {
  activeStep: 0,
  orientation: "horizontal",
  stepItems: null
};
var orientationProps = ["horizontal", "vertical"];
exports.orientationProps = orientationProps;
var _default = Steps;
exports.default = _default;